import Swiper from 'swiper';
import { Navigation, Scrollbar } from 'swiper/modules';

export default function homeQuickAccessSlider() {
  const swiperContainer = document.querySelector('.home-quick-access__slider.swiper') as HTMLDivElement;
  const prevEl = swiperContainer?.querySelector('.swiper-button-prev') as HTMLElement;
  const nextEl = swiperContainer?.querySelector('.swiper-button-next') as HTMLElement;
  const scrollbar = swiperContainer?.querySelector('.swiper-scrollbar') as HTMLElement;

  swiperContainer && new Swiper(swiperContainer, {
    modules: [Navigation, Scrollbar],
    slidesPerView: 1.2,
    centeredSlides: true,
    initialSlide: 1,
    spaceBetween: 24,
    navigation: {
      prevEl,
      nextEl
    },
    scrollbar: {
      el: scrollbar,
      draggable: true,
    },
    breakpoints: {
      576: {
        slidesPerView: 2.5
      },
      768: {
        slidesPerView: 3,
        centeredSlides: false
      }
    }
  })
}